<copo-mill-selector [mills]="mills" [validateChange]="createValidateMillsChange()"
	(millsChange)="onMillsChange($event)"></copo-mill-selector>

<!-- Sub header, and quick search -->
<div class="card-title-block-non-sticky">
	<div class="card-title-label">
		<span translate>ecall-off.choose-order-items</span>
	</div>
	<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
		<input
			[placeholder]="'ecall.searchfield.extendable' | translate"
			matInput
			type="text"
			spellcheck="false"
			autocomplete="off"
			[formControl]="searchTextControl"/>
		<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
		<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
	</mat-form-field>
</div>

<!-- callable order items list -->
<copo-by-volume-order-item-list [currentView]="orderItemsCurrentView"
								[orderItems]="orderItems"
								[selectedOrderItems]="selectedOrderItems"
								[views]="orderItemsViews"
								(changeView)="onChangeView($event)"
								(customizeView)="onCustomizeView($event)"
								(selectOrder)="onSelectOrder($event)"
								(displayOrder)="onDisplayOrder($event)">
</copo-by-volume-order-item-list>
